import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

interface Props {
  open: boolean;
  onConsent: (choice: 'accepted' | 'declined') => void;
}

export const CookieConsentModal: React.FC<Props> = ({ open, onConsent }) => {
  return (
    <Dialog open={open} maxWidth="xs" fullWidth disableEscapeKeyDown>
      <DialogTitle>Cookies &amp; Privacy</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" sx={{ mb: 2 }}>
          <strong>Functional cookies</strong> (always active): Your warband data is stored
          locally in your browser so that it persists between visits. Nothing is sent to
          a server for this purpose.
        </Typography>
        <Typography variant="body2">
          <strong>Analytics cookies</strong> (optional): We use Google Analytics to collect
          anonymous page-view data to help improve the app. You can decline without
          affecting any app functionality.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onConsent('declined')} variant="outlined">
          Decline
        </Button>
        <Button onClick={() => onConsent('accepted')} variant="contained">
          Accept
        </Button>
      </DialogActions>
    </Dialog>
  );
};
